const userGetters = {
  getUsers: (state) => state.users,
  getUser: (state) => state.userModel,
  getMe: (state) => state.user,
  getAdminMe: (state) => state.user_admin,
  getUserFilters: (state) => state.userFilters,
  getFilterUser: (state) => state.filterUsers,
  getCustomer: (state) => state.customer,
  getLangs: (state) => state.langs,
  getAttributes: (state) => state.attributes,
  getAttribute: (state) => state.attribute,
  getOptions: (state) => state.options,
  getOption: (state) => state.option,
  getOptionsSelect: (state) => state.optionsSelect,
  getAttributesSelect: (state) => state.attributesSelect,
  getProductAttributes: (state) => state.product.productAttributes,
  getImageFile: (state) => state.imageFile,
  getIpcFiles: (state) => state.files,
  getUserFiles: (state) => state.userFiles,
  getImportSchema: (state) => state.importSchema,
  getVendorsForSelect: (state) => state.vendorsSelect,
  getSuppliersForSelect: (state) => state.suppliersSelect,
  getRolesSelect: (state) => state.rolesSelect,
  getDealers: (state) => state.dealers,
  getWholesalers: (state) => state.wholesalers,
  getUserOrders: (state) => state.userOrders,
  getBankStatementData: (state) => state.bankStatement,
  getLoginHistory: (state) => state.loginHistory,
  getLoginsHistory: (state) => state.loginsHistory,
  getDeletedUsers: (state) => state.detetedUsers,
  getStaffs: (state) => state.staffs,
  getInactiveUsers: (state) => state.inactiveUsers,
  getCsNumbersToApprove: (state) => state.csNumberToApprove,
  getMessageIbanStatus: (state) => state.messageIbanStatus,
  getAdminRole: (state) => state.admin_role,
  getUserActivity: (state) => state.activities,
  getGlobalActivity: (state) => state.activitiesGlobal,
  getActivityFilters: (state) => state.activityFilters,
  getMenus: (state) => state.menuList,
  getInActiveCustomerNumbers: (state) => state.inActiveCustomerNumbers,
  getInitialUserRole: (state) => state.initialUserRole,
  getUserApps: (state) => state.userApps,
  getUserBoosterList: (state) => state.userBoosterSelect
}

export { userGetters }
